import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.ToolbarHeader', {
    emptyRequestName: 'The approval subject has not been specified.',
    exchangeRateTitle: '{amount} {currency} = {baseAmount} {baseCurrency}',
    draftBadgeText: 'Draft',
    copiedText: 'Copied',
    copyTitle: 'Copy link of the request',
});
